var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2619 50.6065C61.3554 51.0806 60.4205 51.4983 59.4626 51.8574C56.4134 52.9983 53.1833 53.5796 49.9276 53.5732C37.3596 53.5732 26.4117 44.928 26.4117 33.834C26.4278 32.346 26.8407 30.8893 27.6078 29.6142C28.3749 28.3392 29.4684 27.2919 30.7754 26.5806C19.4079 27.0586 16.4863 38.9043 16.4863 45.8443C16.4863 65.4666 34.5708 67.4559 38.4671 67.4559C40.568 67.4559 43.7366 66.845 45.6382 66.2448L45.9862 66.1279C53.304 63.5981 59.5425 58.6523 63.6749 52.1044C63.8015 51.905 63.858 51.6691 63.8355 51.434C63.813 51.1989 63.7128 50.978 63.5508 50.8061C63.3887 50.6343 63.174 50.5214 62.9406 50.4853C62.7072 50.4491 62.4684 50.4917 62.2619 50.6065Z",
    fill: "url(#paint0_linear_13103_6714)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.2619 50.6065C61.3554 51.0806 60.4205 51.4983 59.4626 51.8574C56.4134 52.9983 53.1833 53.5796 49.9276 53.5732C37.3596 53.5732 26.4117 44.928 26.4117 33.834C26.4278 32.346 26.8407 30.8893 27.6078 29.6142C28.3749 28.3392 29.4684 27.2919 30.7754 26.5806C19.4079 27.0586 16.4863 38.9043 16.4863 45.8443C16.4863 65.4666 34.5708 67.4559 38.4671 67.4559C40.568 67.4559 43.7366 66.845 45.6382 66.2448L45.9862 66.1279C53.304 63.5981 59.5425 58.6523 63.6749 52.1044C63.8015 51.905 63.858 51.6691 63.8355 51.434C63.813 51.1989 63.7128 50.978 63.5508 50.8061C63.3887 50.6343 63.174 50.5214 62.9406 50.4853C62.7072 50.4491 62.4684 50.4917 62.2619 50.6065Z",
    fill: "url(#paint1_radial_13103_6714)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9736 64.1197C26.6047 62.6494 24.5517 60.7228 22.934 58.4519C21.0902 55.9257 19.8214 53.0268 19.2166 49.9584C18.6118 46.8899 18.6856 43.7264 19.4329 40.6895C20.1803 37.6526 21.583 34.8161 23.5426 32.3787C25.5023 29.9414 27.9715 27.9623 30.777 26.5803C31.6057 26.1898 33.0213 25.4833 34.9044 25.5179C36.2311 25.5275 37.5375 25.8443 38.7213 26.4433C39.9051 27.0424 40.9341 27.9074 41.7276 28.9706C42.8001 30.4027 43.3915 32.1377 43.4168 33.9267C43.4168 33.8709 49.9133 12.7852 22.1691 12.7852C10.5094 12.7852 0.921308 23.8499 0.921308 33.5575C0.875317 38.6927 1.97406 43.7736 4.13769 48.4309C7.67365 55.9754 13.8571 61.9586 21.5138 65.2445C29.1705 68.5304 37.7673 68.89 45.6717 66.2551C42.9041 67.1277 39.9801 67.3897 37.1014 67.0228C34.2228 66.656 31.4579 65.6692 28.9975 64.1303L28.9736 64.1197Z",
    fill: "url(#paint2_linear_13103_6714)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M28.9736 64.1197C26.6047 62.6494 24.5517 60.7228 22.934 58.4519C21.0902 55.9257 19.8214 53.0268 19.2166 49.9584C18.6118 46.8899 18.6856 43.7264 19.4329 40.6895C20.1803 37.6526 21.583 34.8161 23.5426 32.3787C25.5023 29.9414 27.9715 27.9623 30.777 26.5803C31.6057 26.1898 33.0213 25.4833 34.9044 25.5179C36.2311 25.5275 37.5375 25.8443 38.7213 26.4433C39.9051 27.0424 40.9341 27.9074 41.7276 28.9706C42.8001 30.4027 43.3915 32.1377 43.4168 33.9267C43.4168 33.8709 49.9133 12.7852 22.1691 12.7852C10.5094 12.7852 0.921308 23.8499 0.921308 33.5575C0.875317 38.6927 1.97406 43.7736 4.13769 48.4309C7.67365 55.9754 13.8571 61.9586 21.5138 65.2445C29.1705 68.5304 37.7673 68.89 45.6717 66.2551C42.9041 67.1277 39.9801 67.3897 37.1014 67.0228C34.2228 66.656 31.4579 65.6692 28.9975 64.1303L28.9736 64.1197Z",
    fill: "url(#paint3_radial_13103_6714)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.35 39.5367C41.1348 39.8156 40.4735 40.2007 40.4735 41.04C40.4735 41.7332 40.925 42.3999 41.7271 42.9603C45.5464 45.6163 52.7467 45.2657 52.7653 45.2657C55.5953 45.2589 58.3717 44.493 60.8049 43.0479C63.2596 41.6147 65.2968 39.5645 66.7146 37.1008C68.1323 34.6372 68.8812 31.8456 68.887 29.0032C68.9561 23.0511 66.7623 19.0938 65.8752 17.3408C60.2472 6.33183 48.0988 1.66434e-07 34.888 1.66434e-07C25.9538 -0.000883261 17.3784 3.51517 11.0164 9.7877C4.65438 16.0602 1.01724 24.585 0.891602 33.5183C1.01909 23.8134 10.6656 15.9756 22.1393 15.9756C23.0689 15.9756 28.3703 16.066 33.2944 18.6502C37.6343 20.929 39.9078 23.6806 41.4881 26.4083C43.1295 29.2422 43.4216 32.8225 43.4216 34.2487C43.4216 35.675 42.6939 37.7891 41.35 39.5367Z",
    fill: "url(#paint4_radial_13103_6714)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.35 39.5367C41.1348 39.8156 40.4735 40.2007 40.4735 41.04C40.4735 41.7332 40.925 42.3999 41.7271 42.9603C45.5464 45.6163 52.7467 45.2657 52.7653 45.2657C55.5953 45.2589 58.3717 44.493 60.8049 43.0479C63.2596 41.6147 65.2968 39.5645 66.7146 37.1008C68.1323 34.6372 68.8812 31.8456 68.887 29.0032C68.9561 23.0511 66.7623 19.0938 65.8752 17.3408C60.2472 6.33183 48.0988 1.66434e-07 34.888 1.66434e-07C25.9538 -0.000883261 17.3784 3.51517 11.0164 9.7877C4.65438 16.0602 1.01724 24.585 0.891602 33.5183C1.01909 23.8134 10.6656 15.9756 22.1393 15.9756C23.0689 15.9756 28.3703 16.066 33.2944 18.6502C37.6343 20.929 39.9078 23.6806 41.4881 26.4083C43.1295 29.2422 43.4216 32.8225 43.4216 34.2487C43.4216 35.675 42.6939 37.7891 41.35 39.5367Z",
    fill: "url(#paint5_radial_13103_6714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13103_6714",
    x1: 16.4863,
    y1: 47.0236,
    x2: 63.8529,
    y2: 47.0236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13103_6714",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6476 47.3969) scale(25.3326 24.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13103_6714",
    x1: 41.4594,
    y1: 26.4767,
    x2: 11.8745,
    y2: 58.7015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_13103_6714",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6418 52.8553) rotate(-81.3844) scale(38.0935 30.7757)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_13103_6714",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.7606 12.5831) rotate(92.2906) scale(53.8078 114.599)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_13103_6714",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.654 20.5588) rotate(73.7398) scale(25.8532 21.0238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edge.63710a70c56f1b7aa0ab5ff858a76a71.svg";